import { ExplanationRevisionStatusV2 } from 'src/lib/gql-client'
import { assertNever } from 'src/utils/assertNever'

export const canStartVisit = (status: ExplanationRevisionStatusV2): boolean => {
  switch (status) {
    case 'New':
    case 'SessionStarted':
    case 'SignReady':
    case 'SignStarted':
    case 'SignCompleted':
      return true
    // 同意完了後も遠隔プレスクのVisitを開始できる
    case 'AgreementCompleted':
    case 'DeliveryCompleted':
      return true
    case 'AgreementRejected':
    case 'Disabled':
    case 'Withdrawn':
    case 'Invalid':
      return false
    default:
      return assertNever(status)
  }
}
